import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';

export function useCvesCatalog<TData = Api.V4.Catalog.Cves.Response>(
    payload: Api.V4.Catalog.Cves.Payload,
    options?: UseExposedQueryOptions<Api.V4.Catalog.Cves.Response, Error, TData>
) {
    const notify = useNotify();
    return useQuery<Api.V4.Catalog.Cves.Response, Error, TData>({
        ...options,
        queryKey: Api.V4.Catalog.Cves.QueryKey(payload),
        queryFn: async () => {
            try {
                const response = await new RequestAgent().public.get(Api.V4.Catalog.Cves.Endpoint(), {
                    search: payload
                });

                return response.result;
            } catch (error) {
                notify.openNotification({ level: 'error', message: error.message });
                throw error;
            }
        }
    });
}
